import { AxiosResponse } from "axios";
import { Json } from "./json";
import { HttpClient } from "./http-client";

export abstract class RemoteDataSource {
  constructor(private readonly client: HttpClient) {}

  protected get(url: string, query?: Json): Promise<AxiosResponse> {
    return this.client.get(url, { params: query });
  }

  protected post(
    url: string,
    config?: {
      query?: Json;
      body?: Json;
      headers?: any;
    }
  ): Promise<AxiosResponse> {
    return this.client.post(url, config?.body, {
      params: config?.query,
      headers: config?.headers,
    });
  }

  protected put(url: string, data?: Json): Promise<AxiosResponse> {
    return this.client.put(url, data);
  }

  protected patch(url: string, data?: Json): Promise<AxiosResponse> {
    return this.client.patch(url, data);
  }

  protected delete(url: string): Promise<AxiosResponse> {
    return this.client.delete(url);
  }
}
